import React, { useState, useEffect } from "react";
import TopNavigation from "../../../components/TopNavigation";
import ListQuestion from "../ListQuestion";
import EmptyData from "../../../components/EmptyDataScreen";
import CardIcon from "../CardIcon";
import moment from "moment";
import * as Assets from "../../../utils/svg_assets";
import * as PageRoutes from "../../../utils/route_pages";
import { connect } from "react-redux";
import { Base } from "../../../components/RootLayout";
import { useParams } from "react-router-dom";
import "./style.scss";

const PollingFill = (props) => {
  const params = useParams();
  const { getPollingDetail } = props;
  const [pollingDetail, setPollingDetail] = useState({});
  const [result, setResult] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [isValidateModal, setIsValidateModal] = useState(false);

  const dataIcon = [
    {
      icon: Assets.iconLikeSolid,
      count: pollingDetail?.total_like,
    },
    {
      icon: Assets.iconCommentSolid,
      count: pollingDetail?.survey_comments?.length,
    },
    {
      icon: Assets.iconView,
      count: pollingDetail?.total_view,
    },
  ];

  const getData = async () => {
    const { data, status } = await getPollingDetail(params.pollingId);
    if (status == 200) {
      setPollingDetail(data);
    } else {
      setPollingDetail({});
    }
  };

  useEffect(() => {
    getData();
  }, []);

  props = {
    ...props,
    result,
    setResult,
    isModal,
    setIsModal,
    isValidateModal,
    setIsValidateModal,
    data: pollingDetail.questions,
  };

  return (
    <Base>
      <TopNavigation
        titlePage="Polling"
        toPath={PageRoutes.polling}
        setBorder={true}
        showRightIcon={false}
        iconLeft={Assets.iconBack}
        iconRight={Assets.iconFilter}
      />
      <div className="polling-start-content">
        {pollingDetail.id ? (
          <>
            <div className="content-header">
              <span className="polling-about">
                Polling about {pollingDetail?.read_topics[0]?.name}
              </span>
              <div className="title-wrapper">
                <span className="polling-title">{pollingDetail?.name}</span>
              </div>
              <span className="polling-creator">
                Posted by {pollingDetail?.creator},{" "}
                {moment(pollingDetail?.start).format("DD MMM YYYY")}
              </span>
              <div className="polling-info">
                {dataIcon &&
                  dataIcon.map((a, index) => (
                    <CardIcon key={index} icon={a.icon} count={a.count} />
                  ))}
              </div>
              <div className="polling-point">
                <img src={Assets.iconGoldCoin} alt="logo_image" />
                <div className="point-wrapper">
                  <span className="point">
                    Get {pollingDetail?.points} {pollingDetail?.currency?.name}
                  </span>
                </div>
              </div>
            </div>
            <hr />
            <div className="content-body">
              <ListQuestion {...props} />
            </div>
          </>
        ) : (
          <div className="no-poll-wrapper">
            <EmptyData
              title="There is no poll"
              image={`${process.env.PUBLIC_URL + "/SKOR-Quiz-NoQuiz.png"}`}
              imageStyle={{ width: "170px" }}
              bottomText="Stay tuned for more polls"
            />
          </div>
        )}
      </div>
    </Base>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  getPollingDetail: dispatch.PollingSM.getPollingDetail,
});

export default connect(mapStateToProps, mapDispatchToProps)(PollingFill);
